<template>
<a-col :span="24">
 <a-row class="max1200">
  <a-row class="content">
    <a-col :span="24">
      <a-layout style="min-height: 600px; ">
          <a-layout-content style="background: #fff;">
            <router-view></router-view>
          </a-layout-content>
      </a-layout>
    </a-col>
   </a-row>
  </a-row>
</a-col>
</template>

<script>

export default {
  name: 'E',
  data() {
    return {
        current: ['1']
    }
  },
  components: {
  },
  methods: {
  },
  created() {
  }
}
</script>

<style scoped>
  .max1200 {
      max-width: 1200px;
      margin: auto;
      height: 100%;
      padding: 0px 8px;
  }

  .profile-header {
    background: #fff; 
    //border-right: 1px solid #d1d5da; 
    text-align: left; 
    padding: 8px;
  }

  .profile-header-item {
    padding: 0px 14px;
  }

  .content {
    margin-top: 16px;
    height: 100%;
    //border: 1px solid #d1d5da;
    //border-radius: 3px 3px 0px 0px;
  }
</style>
